// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"43":"a7074efb","554":"4054b060"}[chunkId] + ".chunk.css";
};